import HouseDetailsView from './HouseDetailsViewContainer';
export default HouseDetailsView;
